module.exports = __webpack_public_path__ + "static/pic02-4b4b3ba53c41ec5bad68a985b3da6d5a.jpg";